


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';
import { Favorite } from '../models/favorite';

@Component
export default class FavoriteView extends Vue {
  public items: Common.Favorite[] = new Array();
  public params: Common.FavoriteQuery2 = new Common.FavoriteQuery2();

  public sortOptions: any = [
    { value: 'displayOrder2', text: '表示順' },    
    { value: 'viewName2', text: '表示画面' },
    // { value: 'name', text: '表示名称' },
  ];

  public created(){
    this.params.isAdmin = this.$api.perms.hasMenuPermission(Favorite.perm); //テナント設定権限を要求する
  }

  public showFavoritePage(item: Common.Favorite){
     this.$router.push(item.url);
  }

  public onProvisioning(){
    this.$api.modal.showDialog('確認','テナント共通のお気に入りを初期化してよろしいですか？',false)
    .then(()=>{this.$api.startWaitCusor() ; return this.$api.execute(new Common.FavoriteProvisioningQuery());})
    .then(()=>((this.$refs.mainList) as Components.ListView).reload())
    .then(()=> this.$api.closeWaitCursor());
  }
}
